import { first } from "lodash";
import React from "react";
import PropTypes from "prop-types";
import Button from "antd/lib/button";
import MenuOutlinedIcon from "@ant-design/icons/MenuOutlined";
import Dropdown from "antd/lib/dropdown";
import Menu from "antd/lib/menu";
import Link from "@/components/Link";
import { Auth, currentUser } from "@/services/auth";
import settingsMenu from "@/services/settingsMenu";
import logoUrl from "@/assets/images/redash_icon_small.png";
import { useTheme } from "@/components/ThemeProvider";

import "./MobileNavbar.less";

export default function MobileNavbar({ getPopupContainer }) {
  const firstSettingsTab = first(settingsMenu.getAvailableItems());
  const { isDarkMode, toggleTheme } = useTheme();

  return (
    <div className={`mobile-navbar ${isDarkMode ? 'dark-mode' : 'light-mode'}`}>
      <div className="mobile-navbar-logo">
        <Link href="./dashboards/1-home">
          <img src={logoUrl} alt="Inverse Watch" />
        </Link>
      </div>
      <div>
        <Dropdown
          overlayStyle={{ minWidth: 200 }}
          trigger={["click"]}
          getPopupContainer={getPopupContainer} // so the overlay menu stays with the fixed header when page scrolls
          overlay={
            <Menu mode="vertical" theme={isDarkMode ? "dark" : "light"} selectable={false} className="mobile-navbar-menu">
              {currentUser.hasPermission("list_dashboards") && currentUser.hasPermission("view_query") && (
                <Menu.Item key="favorites">
                  <Link href="./favorites">Favorites</Link>
                </Menu.Item>
              )}
              {currentUser.hasPermission("list_dashboards") && (
                <Menu.Item key="dashboards">
                  <Link href="dashboards">Dashboards</Link>
                </Menu.Item>
              )}
              {currentUser.hasPermission("view_query") && (
                <Menu.Item key="queries">
                  <Link href="queries">Queries</Link>
                </Menu.Item>
              )}
              {currentUser.hasPermission("list_alerts") && (
                <Menu.SubMenu key="alerts" title="Alerts">
                  <Menu.Item key="alerts-list">
                    <Link href="alerts">Alerts</Link>
                  </Menu.Item>
                  <Menu.Item key="alerts-history">
                    <Link href="alert_events">Alerts History</Link>
                  </Menu.Item>
                </Menu.SubMenu>
              )}
              {currentUser.hasPermission("list_indexers") && (
                  <Menu.Item key="indexers-list">
                    <Link href="indexers">Indexers</Link>
                  </Menu.Item>
              )}
              {currentUser.hasPermission("list_models") && (
                <Menu.SubMenu key="ml_models" title="Models">
                <Menu.Item key="models-list">
                  <Link href="ml_models">Models</Link>
                </Menu.Item>
                <Menu.Item key="models-versions-list">
                  <Link href="ml_models_versions">Versions</Link>
                </Menu.Item>
                  <Menu.Item key="predictions-list">
                    <Link href="predictions">Predictions</Link>
                  </Menu.Item>
                </Menu.SubMenu>
              )}
              <Menu.Item key="profile">
                <Link href="users/me">Edit Profile</Link>
              </Menu.Item>
              <Menu.Divider />
              {firstSettingsTab && (
                <Menu.Item key="settings">
                  <Link href={firstSettingsTab.path}>Settings</Link>
                </Menu.Item>
              )}
              {currentUser.hasPermission("super_admin") && (
                <Menu.Item key="status">
                  <Link href="admin/status">System Status</Link>
                </Menu.Item>
              )}
              {currentUser.hasPermission("super_admin") && <Menu.Divider />}
              <Menu.Item key="help">
                {/* eslint-disable-next-line react/jsx-no-target-blank */}
                <Link href="https://docs.inverse.watch/" target="_blank" rel="noopener">
                  Docs
                </Link>
              </Menu.Item>
              <Menu.Item key="landing">
                {/* eslint-disable-next-line react/jsx-no-target-blank */}
                <Link href="https://inverse.watch/" target="_blank" rel="noopener">
                  Landing
                </Link>
              </Menu.Item>
              <Menu.Item key="logout" onClick={() => Auth.logout()}>
                Log out
              </Menu.Item>
              <Menu.Item key="theme-toggle" onClick={toggleTheme}>
                {isDarkMode ? "Switch to Light Mode" : "Switch to Dark Mode"}
              </Menu.Item>
            </Menu>
          }>
          <Button className="mobile-navbar-toggle-button" ghost>
            <MenuOutlinedIcon />
          </Button>
        </Dropdown>
      </div>
    </div>
  );
}

MobileNavbar.propTypes = {
  getPopupContainer: PropTypes.func,
};

MobileNavbar.defaultProps = {
  getPopupContainer: null,
};
